<template>
    <div>
        <vue-headful
                title="Falk Huth | Berufserfahrungen"
                description="Berufserfahrungen von Falk Huth"
        />
        <md-card md-with-hover>
            <md-ripple>
                <md-card-header>
                    <div class="md-title">Berufserfahrungen</div>
                    <div class="md-subhead">
                        in Form einer Auswahl von Themenschwerpunkten
                    </div>
                </md-card-header>

                <md-card-content>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-45 md-xsmall-size-100">
                            <md-subheader class="md-primary" v-if="getCurrentYear() == 2019">
                                <md-icon class="icon-davor md-primary">date_range</md-icon>
                                ab Januar 2020
                            </md-subheader>
                            <md-subheader class="md-primary" v-else>
                                <md-icon class="icon-davor md-primary">date_range</md-icon>
                                seit Januar 2020
                            </md-subheader>
                            <div class="md-body-2">
                                Product Owner ECM/DMS Practice
                            </div>
                            <div class="md-body-1">
                                <a href="https://www.ewerk.com" target="_blank">EWERK Group</a>, Leipzig
                            </div>
                            <ul>
                                <li>
                                    Entwurf und Erweiterung des
                                    <span>
                                        <a href="https://de.wikipedia.org/wiki/Enterprise-Content-Management" target="_blank">ECM</a>
                                        <md-tooltip md-direction="bottom">Enterprise-Content-Management</md-tooltip>
                                    </span>
                                    und
                                    <span>
                                        <a href="https://de.wikipedia.org/wiki/Dokumentenmanagement" target="_blank">DMS</a>
                                        <md-tooltip md-direction="bottom">Dokumenten-Management-System</md-tooltip>
                                    </span>
                                    Portfolios
                                </li>
                                <li>
                                    Betrieb einer hochverfügbaren und skalierbaren Plattform
                                    für das ECM/DMS-Portfolio inkl. Aufbau eines ECM-Teams bei EWERK
                                </li>
                                <li>
                                    Partnerschaften und Kundenbeziehungen zu diesem Thema
                                </li>
                            </ul>
                        </div>
                        <div class="md-layout-item md-size-5 md-xsmall-hide">
                        </div>
                        <div class="md-layout-item md-size-45 md-xsmall-size-100">
                            <md-subheader class="md-primary">
                                <md-icon class="icon-davor md-primary">date_range</md-icon>
                                April 2018 - Dezember 2019
                            </md-subheader>
                            <div class="md-body-2">
                                Projektmanager ECM-System (DMS)
                            </div>
                            <div class="md-body-1">
                                <a href="https://www.hs-anhalt.de" target="_blank">Hochschule Anhalt -
                                    Anhalt University of Applied Sciences</a>, Köthen
                            </div>
                            <ul>
                                <li>Elektronische Studierendenakte inkl. Anbindung
                                    <a href="https://www.his.de/produkte/hisinone.html" target="_blank">HISinOne</a></li>
                                <li>Digitale Workflows, Plattform
                                    <a href="https://www.d-velop.de" target="_blank">d.3ecm</a>, z.B. Drittmittelprojektanzeige</li>
                                <li>Koordination <a href="https://www.codia.de" target="_blank">externer Dienstleister</a>
                                    und interner IT-Verantwortlicher</li>
                                <li>Personalverantwortung im Projekt</li>
                            </ul>
                        </div>
                        <div class="md-layout-item md-size-5 md-xsmall-hide">
                        </div>
                        <div class="md-layout-item md-size-45 md-xsmall-size-100">
                            <md-divider></md-divider>
                            <md-subheader class="md-primary">
                                <md-icon class="icon-davor md-primary">date_range</md-icon>
                                September 2012 - März 2018
                            </md-subheader>
                            <div class="md-body-2">
                                Senior Consultant ERP/CRM
                            </div>
                            <div class="md-body-1">
                                <a href="https://www.mobileblox.de" target="_blank">mobileBlox GmbH</a>, Leipzig
                            </div>
                            <ul>
                                <li>eigenes CRM-Produkt mit Anbindung an das ERP-System
                                    <a href="https://www.proalpha.com/de" target="_blank">proALPHA</a></li>
                                <li>Consulting bei Kunden-Workshops, Schulung der Key-User bei Kunden</li>
                                <li>Konzeption und Betreuung der Umsetzung neuer Produkt-Module</li>
                            </ul>
                        </div>
                        <div class="md-layout-item md-size-5 md-xsmall-hide">
                        </div>
                        <div class="md-layout-item md-size-45 md-xsmall-size-100">
                            <md-divider></md-divider>
                            <md-subheader class="md-primary">
                                <md-icon class="icon-davor md-primary">date_range</md-icon>
                                Oktober 2004 - August 2012
                            </md-subheader>
                            <div class="md-body-2">
                                Software-Engineer / Projektleiter interne ERP-Einführung und -Betreuung
                            </div>
                            <div class="md-body-1">
                                itCampus Software- und Systemhaus GmbH, Leipzig
                            </div>
                            <ul>
                                <li>Konzeption und Entwicklung einer Portallösung im Rahmen des
                                Verbundforschungsprojekts
                                    <a href="http://publica.fraunhofer.de/dokumente/N-59169.html"
                                       target="_blank">servingo</a> für die FIFA-WM 2006&trade;</li>
                                <li>Projektleitung für die Auswahl, Einführung und Betreuung des firmeninternen
                                    ERP-Systems <a href="https://www.proalpha.com/de" target="_blank">proALPHA</a></li>
                            </ul>
                        </div>
                        <div class="md-layout-item md-size-5 md-xsmall-hide">
                        </div>
                        <div class="md-layout-item md-size-45 md-xsmall-size-100">
                            <md-divider></md-divider>
                            <md-subheader class="md-primary">
                                <md-icon class="icon-davor md-primary">date_range</md-icon>
                                Juli 2003 - September 2004
                            </md-subheader>
                            <div class="md-body-2">
                                Wissenschaftlicher Mitarbeiter
                            </div>
                            <div class="md-body-1">
                                Klinikum der Medizinischen Fakultät<br/>
                                <a href="http://www.uni-halle.de" target="_blank">Martin-Luther-Universität
                                Halle-Wittenberg</a>
                            </div>
                            <ul>
                                <li>Forschungsprojekt im Bereich Orthopädie (Endoprothetik)</li>
                            </ul>
                        </div>
                        <div class="md-layout-item md-size-5 md-xsmall-hide">
                        </div>
                        <div class="md-layout-item md-size-45 md-xsmall-size-100">
                            <md-divider></md-divider>
                            <md-subheader class="md-primary">
                                <md-icon class="icon-davor md-primary">date_range</md-icon>
                                Oktober 2002 - Juni 2003
                            </md-subheader>
                            <div class="md-body-2">
                                Software-Engineer mit Projektleitung
                            </div>
                            <div class="md-body-1">
                                itCampus Software- und Systemhaus GmbH, Leipzig
                            </div>
                            <ul>
                                <li>Projektleitung für bis zu 9 Entwickler bei der Entwicklung eines
                                Wetterinformationssystems für die Bundeswehr</li>
                            </ul>
                        </div>
                    </div>
                </md-card-content>
            </md-ripple>
        </md-card>
    </div>
</template>

<script>
    export default {
        name: "Berufserfahrungen",
        methods: {
            getCurrentYear() {
                return new Date().getFullYear();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .md-subheader {
        padding-left: 0!important;
    }
    .icon-davor {
        margin-left: 0px;
        margin-right: 5px;
    }
</style>
